import { Component, Input, ViewEncapsulation } from '@angular/core';

import type { GDPRReport } from '../../components/email-gdpr-reports/email-gdpr-reports.component';
import { EmailGdprReportsComponent } from '../../components/email-gdpr-reports/email-gdpr-reports.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-gdpr-report-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './gdpr-report.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailGdprReportsComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class GdprReportTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<GdprReportTemplateData>;
}

export type GdprReportTemplateData = {
  title: string;
  button_link: string;
  button_text: string;
  p1: string;
  reports: GDPRReport[];
  footer_p1: string;
  footer_text: 'test_footer_text';
  footer_link: 'test_footer_link';
  footer_link_text: 'test_footer_link_text';
};

export const GdprReportTemplateMocks: GdprReportTemplateData[] = [
  {
    title: 'GDPR Report',
    button_link: 'http://recruitee.com',
    button_text: 'Open on web',
    p1: 'ACME',
    reports: [
      {
        title: 'Changes since last report',
        period: '24 Aug - 4 Sep',
        items: [
          {
            new: true,
            new_label: 'New',
            title: 'Expired candidate profiles',
            value: '30',
          },
          {
            new: false,
            new_label: 'New',
            title: 'Expired candidate profiles',
            value: '11',
          },
          {
            new: true,
            new_label: 'New',
            title: 'Expired candidate profiles',
            value: '12',
          },
        ],
      },
    ],
    footer_text: 'test_footer_text',
    footer_link: 'test_footer_link',
    footer_link_text: 'test_footer_link_text',
    footer_p1: 'Cant access? Contact your admin.',
  },
];
